<template>
	<div class="tile" :style="tileColor">{{ title }}</div>
</template>

<script>
export default {
	name: 'tag',
	props: {
		id: { required: true, type: Number },
		title: { required: true, type: String },
		color: { required: false, type: String },
	},
	computed: {
		tileColor() {
			return {
				'--tileBackgroundColor': this.color || '#517fa8',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.tile {
	height: 17px;
	margin: 0 2px;
	font-size: 10px;
	border-radius: 8px;
	background-color: var(--tileBackgroundColor);
	color: #fff;
	padding: 1px 6px;
}
</style>
